import { ButtonHTMLAttributes, forwardRef } from 'react';
import styled from 'styled-components';
import closeIcon from '../../Image/ic_closeX.png';

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & { tone?: 'user' | 'admin' };

const ModalCloseButton = forwardRef<HTMLButtonElement, Props>(function ModalCloseButton({ tone = 'user', 'aria-label': label = '닫기', ...props }, ref) {
  const admin = tone === 'admin';
  return <Button {...props} ref={ref} type="button" aria-label={label} $admin={admin}>
    {admin ? <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" /></svg> : <img src={closeIcon} alt="" />}
  </Button>;
});
export default ModalCloseButton;

const Button = styled.button<{ $admin: boolean }>`
  && {
    box-sizing: border-box;
    flex: none;
    width: 44px;
    min-width: 44px;
    height: 44px;
    min-height: 44px;
    margin: 0;
    padding: 0;
    display: inline-grid;
    place-items: center;
    border: ${({ $admin }) => $admin ? '1px solid var(--color-border-default)' : '0'};
    border-radius: ${({ $admin }) => $admin ? 'var(--radius-md)' : '6px'};
    background: ${({ $admin }) => $admin ? 'var(--color-bg-surface)' : 'transparent'};
    color: ${({ $admin }) => $admin ? 'var(--color-text-primary)' : 'inherit'};
    cursor: pointer;
  }
  && > :is(svg, img) { width: 22px; height: 22px; }
  && > svg { fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; }
  && > img { filter: var(--user-icon-filter); }
  &&:hover:not(:disabled) { background: ${({ $admin }) => $admin ? 'var(--color-bg-subtle)' : 'var(--user-surface-raised)'}; }
  &&:active:not(:disabled) { background: ${({ $admin }) => $admin ? 'var(--color-bg-muted)' : 'transparent'}; }
  &&:disabled { opacity: ${({ $admin }) => $admin ? 1 : .5}; color: ${({ $admin }) => $admin ? 'var(--color-text-disabled)' : 'inherit'}; cursor: default; }
  &&:focus-visible { outline: 2px solid ${({ $admin }) => $admin ? 'var(--color-brand)' : 'var(--user-accent)'}; outline-offset: 2px; }
`;
